
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.47 2.47a.75.75 0 011.06 0L12 6.94l1.97-1.97 1.5-1.5a3.578 3.578 0 115.06 5.06l-1.498 1.5h-.002v.002L17.06 12l4.47 4.47a.75.75 0 010 1.06l-4 4a.75.75 0 01-1.06 0l-2.5-2.5L12 17.06l-4.47 4.47a.75.75 0 01-.53.22H3a.75.75 0 01-.75-.75v-4a.75.75 0 01.22-.53L6.94 12l-1.97-1.97-2.5-2.5a.75.75 0 010-1.06l4-4zM13.06 16l1.44 1.44.97-.97a.75.75 0 111.06 1.06l-.97.97L17 19.94 19.94 17 16 13.06 13.06 16zm2.41-4.53l1.97-1.97-2.94-2.94-1.968 1.969-.002.001-.001.002-3.997 3.997-.002.001-.001.002L4.03 17.03l2.94 2.94 4.5-4.5 4-4zM10.94 8L8 10.94 6.56 9.5l.97-.97a.75.75 0 00-1.06-1.06l-.97.97L4.06 7 7 4.06 10.94 8zm7.56.44L15.56 5.5l.97-.97a2.079 2.079 0 012.94 2.94l-.97.97z"}})])
          )
        }
      }
    